import { ROUTER_PATHS } from "@/shared/constants"
import { UiFullscreenSpinner } from "@/shared/ui"
import { notifyExtension } from "@/shared/utils/notify-extension"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "sonner"

export const CheckoutPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const initHandler = async () => {
      const queryParams = new URLSearchParams(location.search)
      const extensionId = queryParams.get("extensionId")
      if (queryParams.get("status") === "success") {
        await notifyExtension(extensionId, "EXTENSION_CHECKOUT_COMPLETED")
        toast.success("You’re now on Frateca Pro")
      }
      navigate(ROUTER_PATHS.APP)
    }
    initHandler()
  }, [])

  return <UiFullscreenSpinner />
}
